var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoaded ? _c('auction-category-select', _vm._b({
    attrs: {
      "returnObject": "",
      "clearable": "",
      "rowClass": "ma-n2 pa-2",
      "colClass": "pa-2",
      "cols": "12",
      "sm": "12"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  }, 'auction-category-select', Object.assign({}, _vm.attrs_input, {
    categories: _vm.categories,
    md: _vm.md
  }), false)) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }